<template>
  <div>
    <form-field-select
      label="Status"
      v-model="form.status"
      :validation-errors="validationErrors.status"
    >
      <option
        v-for="status in statuses"
        :key="status.value"
        :value="status.value"
      >{{ status.label }}</option>
    </form-field-select>

    <form-field-currency
      label="Listing Price"
      v-model="form.listing_price"
      :validation-errors="validationErrors.listing_price"
    />

    <form-field-currency
      label="Final Sales Price"
      v-model="form.final_sales_price"
      :validation-errors="validationErrors.final_sales_price"
    />

    <form-field-input
      label="Agent Commission"
      v-model="form.agent_commission"
      type="number"
      :validation-errors="validationErrors.agent_commission"
    >
      <template v-slot:after>
        <p class="control">
          <span class="button is-small field-button">%</span>
        </p>
      </template>
    </form-field-input>

    <form-field-currency
      label="Other Selling Costs"
      v-model="form.other_selling_costs"
      :validation-errors="validationErrors.other_selling_costs"
    />

    <form-field-date-picker
      label="Accepted At"
      v-model="form.accepted_at"
      :validation-errors="validationErrors.accepted_at"
      is-inline
      has-clear-button
    />

    <form-field-date-picker
      label="Contracted At"
      v-model="form.contracted_at"
      :validation-errors="validationErrors.contracted_at"
      is-inline
      has-clear-button
    />

    <form-field-date-picker
      label="Closing At"
      v-model="form.closing_at"
      :validation-errors="validationErrors.closing_at"
      is-inline
      has-clear-button
    />
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {ENUMS} from "../services/enums";
import api from "../api";

export default {
  name: "RetailListingSellingInfoForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        record_id: this.$store.state.activeRecord.record.id,
        listing_price: '',
        final_sales_price: '',
        agent_commission: '',
        other_selling_costs: '',
        status: '',
        accepted_at: '',
        contracted_at: '',
        closing_at: '',
      },
    }
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the creation
    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  computed: {
    statuses() {
      return ENUMS.RetailListingSellingInfoStatusEnum;
    }
  },
  methods: {
    update() {
      return api.sellingInfos.retailListing.update(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Retail Listing Selling Info was updated',
            type: 'is-success'
          });

          return res;
        });
    },
    create() {
      return api.sellingInfos.retailListing.create(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Retail Listing Selling Info was created',
            type: 'is-success'
          });

          return res;
        });
    }
  },
}
</script>

<style scoped lang="scss">

</style>
